var cartDrawer = function() {
    return {
        open: !1,
        usedKeyboard: !1,
        init: function() {
            var t = this;
            this.$watch("open", function(e) {
                e && t.$refs.closeButton.focus(), t.toggleOverlay()
            }), this.toggleOverlay()
        },
        toggleOverlay: function() {
            document.body.classList[this.open ? "add" : "remove"]("h-screen", "overflow-hidden")
        }
    }
};

function _createForOfIteratorHelper(t, e) {
    var r;
    if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
        if (Array.isArray(t) || (r = _unsupportedIterableToArray(t)) || e && t && "number" == typeof t.length) {
            r && (t = r);
            var n = 0,
                o = function() {};
            return {
                s: o,
                n: function() {
                    return n >= t.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t[n++]
                    }
                },
                e: function(t) {
                    throw t
                },
                f: o
            }
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }
    var a, i = !0,
        u = !1;
    return {
        s: function() {
            r = t[Symbol.iterator]()
        },
        n: function() {
            var t = r.next();
            return i = t.done, t
        },
        e: function(t) {
            u = !0, a = t
        },
        f: function() {
            try {
                i || null == r.return || r.return()
            } finally {
                if (u) throw a
            }
        }
    }
}

function _unsupportedIterableToArray(t, e) {
    if (t) {
        if ("string" == typeof t) return _arrayLikeToArray(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(t, e) : void 0
    }
}

function _arrayLikeToArray(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
    return n
}
var _step, matches = document.querySelectorAll(".frontpage-collection"),
    _iterator = _createForOfIteratorHelper(matches);
try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var match = _step.value,
            glide = new Glide(match, {
                type: "carousel",
                animationDuration: 500,
                focusAt: "1",
                startAt: 1,
                perView: 4,
                gap: 20,
                breakpoints: {
                    600: {
                        perView: 1
                    },
                    800: {
                        perView: 2
                    },
                    1000: {
                        perView: 3
                    },
                    1200: {
                        perView: 4
                    }
                }
            });
        glide.mount()
    }
} catch (t) {
    _iterator.e(t)
} finally {
    _iterator.f()
}
var productMobileSlider = function() {
        new Glide("#product-mobile-slider", {
            type: "slider",
            startAt: 0,
            perView: 1
        }).mount()
    },
    productSlider = function() {
        var t = new Glide("#product-slider", {
            type: "carousel",
            startAt: 0,
            perView: 1,
        }).mount();
        if (window.productSlider = t, null !== document.getElementById("slider-nav")) {
            var e = new Glide("#slider-nav", {
                type: "carousel",
                perView: 4,
                breakpoints: {
                    600: {
                        perView: 4
                    },
                    800: {
                        perView: 4
                    },
                    1000: {
                        perView: 4
                    },
                    1200: {
                        perView: 4
                    }
                },
                peek: {
                    before: 0,
                    after: 50
                },
                bound: !0
            }).mount();
            Array.from(document.querySelectorAll(".slide-nav")).forEach(function(r) {
                r.addEventListener("click", function(r) {
                    t.go("=" + r.target.dataset.index), e.go("=" + r.target.dataset.index)
                })
            }), t.on("swipe.end", function() {
                e.go("=" + t.index)
            }), t.on("move.after", function() {
                e.go("=" + t.index)
            })
        }
    };

function _createForOfIteratorHelper(t, e) {
    var r;
    if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
        if (Array.isArray(t) || (r = _unsupportedIterableToArray(t)) || e && t && "number" == typeof t.length) {
            r && (t = r);
            var n = 0,
                o = function() {};
            return {
                s: o,
                n: function() {
                    return n >= t.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t[n++]
                    }
                },
                e: function(t) {
                    throw t
                },
                f: o
            }
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }
    var a, i = !0,
        u = !1;
    return {
        s: function() {
            r = t[Symbol.iterator]()
        },
        n: function() {
            var t = r.next();
            return i = t.done, t
        },
        e: function(t) {
            u = !0, a = t
        },
        f: function() {
            try {
                i || null == r.return || r.return()
            } finally {
                if (u) throw a
            }
        }
    }
}

function _unsupportedIterableToArray(t, e) {
    if (t) {
        if ("string" == typeof t) return _arrayLikeToArray(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(t, e) : void 0
    }
}

function _arrayLikeToArray(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var r = 0, n = new Array(e); r < e; r++) n[r] = t[r];
    return n
}
var productDetails = function() {
    return {
        product: null,
        selectedVariant: null,
        variantInCart: false,
        init: function(t, e) {
            this.product = t, this.selectedVariant = t.variants.find(function(t) {
                return t.id == e
            });
            this.checkVariantInCart();
            // Re-check after any cart change (e.g. item removed from drawer)
            var self = this;
            jQuery(document).on('cart.requestComplete', function() {
                self.checkVariantInCart();
            });
        },
        checkVariantInCart: function() {
            var self = this;
            if (!self.selectedVariant) {
                console.log('[checkVariantInCart] no selectedVariant');
                return;
            }
            jQuery.getJSON('/cart.js', function(cart) {
                var found = cart.items.some(function(item) {
                    return item.variant_id == self.selectedVariant.id &&
                           !(item.properties && item.properties._pfand_deposit === 'true');
                });
                console.log('[checkVariantInCart] variant:', self.selectedVariant.id, 'found:', found, 'cart items:', cart.items.length);
                self.variantInCart = found;
            });
        },
        _addBusy: false,
        addToCart: function() {
            var self = this;
            console.log('[addToCart] clicked — variant:', self.selectedVariant ? self.selectedVariant.id : 'none', 'variantInCart:', self.variantInCart, '_addBusy:', self._addBusy);

            // Hard lock — prevents any concurrent add
            if (self._addBusy) {
                console.log('[addToCart] BLOCKED — add already in progress');
                return;
            }
            self._addBusy = true;
            self.variantInCart = true;

            // Always verify against real cart before adding
            jQuery.getJSON('/cart.js', function(cart) {
                var alreadyInCart = cart.items.some(function(item) {
                    return item.variant_id == self.selectedVariant.id &&
                           !(item.properties && item.properties._pfand_deposit === 'true');
                });
                console.log('[addToCart] fresh cart check — alreadyInCart:', alreadyInCart);

                if (alreadyInCart) {
                    console.log('[addToCart] BLOCKED — variant already in cart (verified)');
                    self._addBusy = false;
                    return;
                }

                $('.addtocart-message').removeClass('message-error').html('');

                var selling_plan = $('input[name="selling_plan"]').val();
                var qtyEl = document.getElementById("quantity");
                var mainQuantity = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;

                function openCartDrawer() {
                    self._addBusy = false;
                    var ct = document.getElementById('cart-trigger');
                    if (ct) ct.click();
                }

                // Check if this variant requires Pfand deposit
                var canCount = (typeof variantCanCounts !== 'undefined') ? (variantCanCounts[self.selectedVariant.id] || 0) : 0;
                var mainProps = {"selling_plan": selling_plan};
                if (canCount > 0) {
                    mainProps["_can_count"] = String(canCount);
                }

                console.log('[addToCart] adding variant:', self.selectedVariant.id, 'qty:', mainQuantity, 'canCount:', canCount);

                CartJS.addItem(self.selectedVariant.id, mainQuantity, mainProps, {
                    "success": function(data, textStatus, jqXHR) {
                        console.log('[addToCart] SUCCESS — variant added:', self.selectedVariant.id);
                        if (canCount > 0 && typeof pfandVariantId !== 'undefined' && pfandVariantId) {
                            var pfandQty = canCount * mainQuantity;
                            CartJS.addItem(pfandVariantId, pfandQty, {"_pfand_deposit": "true"}, {
                                "success": function() {
                                    console.log('[addToCart] Pfand added, qty:', pfandQty);
                                    openCartDrawer();
                                },
                                "error": function() {
                                    console.log('[addToCart] Pfand add error');
                                    openCartDrawer();
                                }
                            });
                        } else {
                            openCartDrawer();
                        }
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.log('[addToCart] ERROR:', jqXHR.responseJSON ? jqXHR.responseJSON.description : errorThrown);
                        self.variantInCart = false;
                        self._addBusy = false;
                        $('.addtocart-message').addClass('message-error');
                        $('.addtocart-message').html(jqXHR.responseJSON.description);
                    }
                });
            });
        },
        changeVariantImage: function() {
            if (this.selectedVariant) {
                var t = this.selectedVariant.featured_image;
                if (t || this.product.hasSubscription) {
                    var e = t ? t.id.toString() : 0;
                    if (void 0 !== window.productSlider) {
                        var r, n = document.querySelectorAll("#product-slider li"),
                            o = 0,
                            a = _createForOfIteratorHelper(n);
                        try {
                            for (a.s(); !(r = a.n()).done;) {
                                var i = r.value;
                                if (i.getAttribute("data-id").toString() == e || i.getAttribute("data-variant-id").toString() == this.selectedVariant.id.toString()) {
                                    window.productSlider.go("=" + (o - 1));
                                    break
                                }
                                o++
                            }
                        } catch (t) {
                            a.e(t)
                        } finally {
                            a.f()
                        }
                    }
                }
            }
        },
        selectVariant: function(t) {
            this.selectedVariant = this.product.variants.find(function(e) {
                return e.id == t
            }), this.changeVariantImage();
            this.checkVariantInCart();
            var new_url="?variant=" +t;
            window.history.replaceState("null","null",new_url);

          $('.bg-white').click(function(){
            console.log($(this).attr('data-variant'));

            if(t==46124571590848){
             $('.show-des-3er-Geschenk-Box').show();
             $('.show-des-12er-Paket').hide();
             $('.show-des-3-Monats-Abo').hide();
           } else if(t==46124571623616){
             $('.show-des-3er-Geschenk-Box').hide();
             $('.show-des-12er-Paket').show();
             $('.show-des-3-Monats-Abo').hide();
           } else if(t==46124581585088){
             $('.show-des-3er-Geschenk-Box').hide();
             $('.show-des-12er-Paket').hide();
             $('.show-des-3-Monats-Abo').show();
           } else {
             $('.show-des-3er-Geschenk-Box').show();
             $('.show-des-12er-Paket').hide();
             $('.show-des-3-Monats-Abo').hide();
           }
            
          })
        },
        selectSellingPlan: function(t){
          $('input[name="selling_plan"]').val(t);
        }
    }
};

function _typeof(t) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
    })(t)
}
var setCookie = function(t, e) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 7,
            n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "/",
            o = new Date(Date.now() + 864e5 * r).toUTCString();
        document.cookie = t + "=" + encodeURIComponent(e) + "; expires=" + o + "; path=" + n
    },
    getCookie = function(t) {
        return document.cookie.split("; ").reduce(function(e, r) {
            var n = r.split("=");
            return n[0] === t ? decodeURIComponent(n[1]) : e
        }, "")
    },
    deleteCookie = function(t, e) {
        setCookie(t, "", -1, e)
    },
    store = function(t, e) {
        var r = !1;
        if (localStorage && (r = !0), null != e && ("object" === _typeof(e) && (e = JSON.stringify(e)), r ? localStorage.setItem(t, e) : n(t, e, 30)), void 0 === e) {
            data = r ? localStorage.getItem(t) : function(t) {
                for (var e = t + "=", r = document.cookie.split(";"), n = 0, o = r.length; n < o; n++) {
                    for (var a = r[n];
                        " " === a.charAt(0);) a = a.substring(1, a.length);
                    if (0 === a.indexOf(e)) return a.substring(e.length, a.length)
                }
                return null
            }(t);
            try {
                data = JSON.parse(data)
            } catch (t) {
                data = data
            }
            return data
        }

        function n(t, e, r) {
            var n = new Date;
            n.setTime(n.getTime() + 24 * r * 60 * 60 * 1e3);
            var o = "; expires=" + n.toGMTString();
            document.cookie = t + "=" + e + o + "; path=/"
        }
        null === e && (r ? localStorage.removeItem(t) : n(t, "", -1))
    };